var map = {
	"./docscan.png": "4693",
	"./docscanpro.png": "84bf",
	"./download.png": "f6f5",
	"./empty_doc.png": "ec6c",
	"./fasterscan.png": "21df",
	"./folder.png": "f27d",
	"./folder_lock.png": "8533",
	"./folder_unlock.png": "f98b",
	"./loading_doc.png": "419f",
	"./scannerapp.png": "588c",
	"./scannerapppro.png": "48c2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";